import React, { FC, forwardRef, ReactNode, ForwardedRef, ElementType } from 'react';
import { Tab, TabProps } from '@mui/material';

export interface SecondaryNavigationItemProps extends Omit<TabProps<ElementType>, 'children'> {
  /**
   * Displayed navigation text, can be provided as children as well
   */
  label?: ReactNode;
  /**
   * Displayed navigation text
   */
  children?: ReactNode;
}

/**
 * Component to render styled button in the header
 */
export const SecondaryNavigationItem: FC<SecondaryNavigationItemProps> = forwardRef(
  ({ children, label, ...rest }, ref) => {
    return (
      <Tab
        label={children || label}
        ref={ref as ForwardedRef<HTMLDivElement>}
        data-testid="SecondaryNavigationItem"
        {...rest}
      />
    );
  },
);
